import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import BenefitsSection from './components/BenefitsSection';
import CategoryGrid from './components/CategoryGrid';
import AboutSection from './components/AboutSection';
import BlogGrid from './components/BlogGrid';
import CTASection from './components/CTASection';
import TestimonialSection from './components/TestimonialSection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Best Sugargoo Spreadsheet 2026 - Complete Guide & Directory",
            "description": "Discover the most complete Sugargoo Spreadsheet 2026 with categorized sneakers, clothing, accessories, and budget finds. Updated daily with trusted community links and buying guides.",
            "url": "https://sugargoospreadsheet.work/",
            "mainEntity": {
              "@type": "FAQPage",
              "mainEntity": [
                {
                  "@type": "Question",
                  "name": "What is a Sugargoo Spreadsheet?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "A Sugargoo Spreadsheet is a curated collection of product links organized by category, helping shoppers find the best sneakers, clothing, and accessories available through Sugargoo. Each entry is verified by the community for quality and reliability."
                  }
                },
                {
                  "@type": "Question",
                  "name": "How often is the spreadsheet updated?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Our spreadsheet directory is updated daily with new finds and refreshed links. Dead links are removed promptly, and new product discoveries are added as the community shares them."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Is the spreadsheet free to use?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Absolutely. The Sugargoo Spreadsheet directory is completely free to browse. All product links redirect to our main platform where you can explore and shop at your convenience."
                  }
                }
              ]
            }
          })}
        </script>
        <HeroSection />
        <BenefitsSection />
        <CategoryGrid />
        <AboutSection />
        <BlogGrid />
        <CTASection />
        <TestimonialSection />
      </main>
      <Footer />
    </>
  );
}